const initialState = {
  mode: "NORMAL",
  sidebarOpenKeys: [],
  sidebarCollapsed: false,
  activePanelKey: null,
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_MODE":
      return {
        ...state,
        mode: state.mode === "NORMAL" ? "SETTINGS" : "NORMAL",
      };

    case "SET_MODE":
      return {
        ...state,
        mode: action.payload,
      };

    case "SET_SIDEBAR_OPEN_KEYS":
      return { ...state, sidebarOpenKeys: action.payload };

    case "SET_SIDEBAR_COLLAPSED":
      return { ...state, sidebarCollapsed: action.payload };

    case "SET_ACTIVE_PANEL_KEY":
      return { ...state, activePanelKey: action.payload };

    default:
      return state;
  }
};

export default uiReducer;
